/**
 * Layout Context for managing sidebar state across the app
 */

import React, { createContext, useContext, useState, ReactNode } from 'react';

interface LayoutContextType {
  isSidebarExpanded: boolean;
  setSidebarExpanded: (expanded: boolean) => void;
  toggleSidebar: () => void;
} 

const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

export const LayoutProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);

  const setSidebarExpanded = (expanded: boolean) => {
    setIsSidebarExpanded(expanded);
  };

  const toggleSidebar = () => {
    setIsSidebarExpanded(prev => !prev);
  };

  return (
    <LayoutContext.Provider value={{ isSidebarExpanded, setSidebarExpanded, toggleSidebar }}>
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayout = (): LayoutContextType => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
};
